import { createActionsHook } from 'src/lib/sweetState';

import { NotificationStore } from './NotificationStore';

export const useNotificationActions = createActionsHook(NotificationStore);
